import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Params,
} from "@angular/router";
import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";

import * as fromRouter from "@ngrx/router-store";
import { Injectable } from "@angular/core";

export interface RouterStateUrl {
    // can extend this for our own use-cases
    url: string;
    queryParams: Params;
    params: Params;
    studentHomePageOpen: boolean;
    studentResourcesPageOpen: boolean;
    studentResourcePageOpen: boolean;
    studentAssignmentsListPageOpen: boolean;
    studentSingularAssignmentPageOpen: boolean;
    studentCompositeAssignmentPageOpen: boolean;
    studentEditProfilePageOpen: boolean;
    studentMessagesPageOpen: boolean;
    showLaunchInNewButton: boolean;
    showAssignmentInfoButton: boolean;
    showAssignmentTeacherFeedbackButton: boolean;
}

export interface State {
    routerReducer: fromRouter.RouterReducerState<RouterStateUrl>;
}

export const reducers: ActionReducerMap<State> = {
    routerReducer: fromRouter.routerReducer,
};

// selector: so we can ask for a particular state
export const getRouterState =
    createFeatureSelector<fromRouter.RouterReducerState<RouterStateUrl>>(
        "routerReducer"
    );

// this runs every time user navigates to new url and updates our store
@Injectable()
export class CustomSerializer
    implements fromRouter.RouterStateSerializer<RouterStateUrl>
{
    // go into RouterStateSnapshot source code. It extends ActivatedRouteSnapshot
    // go into that to see everything available
    serialize(routerState: RouterStateSnapshot): RouterStateUrl {
        // get url from the routerState
        // same as: const url = routerState.url
        // think of these as imports!
        // We want the queryParams from the routerState.root and make it a const
        const { url } = routerState;
        const { queryParams } = routerState.root;

        // get the param if there is any (teacher-classes/545) we get the 545
        let state: ActivatedRouteSnapshot = routerState.root;
        while (state.firstChild) {
            state = state.firstChild;
        }
        const { params } = state;

        let studentHomePageOpen = false;
        let studentResourcesPageOpen = false;
        let studentResourcePageOpen = false;
        let studentAssignmentsListPageOpen = false;
        let studentSingularAssignmentPageOpen = false;
        let studentCompositeAssignmentPageOpen = false;
        let studentEditProfilePageOpen = false;
        let studentMessagesPageOpen = false;
        let showLaunchInNewButton = false;
        let showAssignmentInfoButton = false;
        let showAssignmentTeacherFeedbackButton = false;

        if (url === "/student") {
            document.title = "Carnegie Learning";
            studentHomePageOpen = true;
        }
        if (
            url === "/student/resources" ||
            url === "/student/resources/courses/" + params.courseID
        ) {
            studentResourcesPageOpen = true;
        }
        if (
            url ===
            "/student/resources/courses/" +
                params.courseID +
                "/" +
                params.editionId +
                "/resource/" +
                params.assetId
        ) {
            studentResourcePageOpen = true;
            showLaunchInNewButton = true;
        }

        if (url.includes("assignments")) {
            // TODO figure out how this page thing works, page 3 is deleted now that completed route is gone
            if (url.includes("lesson")) {
                studentCompositeAssignmentPageOpen = true;
                showAssignmentInfoButton = true;
                showAssignmentTeacherFeedbackButton = true;
            } else if (
                params.assignmentID &&
                !params.compositeTaskAssignmentID
            ) {
                studentSingularAssignmentPageOpen = true;
                showAssignmentInfoButton = true;
                showAssignmentTeacherFeedbackButton = true;
                showLaunchInNewButton = true;
            } else {
                studentAssignmentsListPageOpen = true;
            }
        }
        if (url.includes("student/profile/edit-student")) {
            studentEditProfilePageOpen = true;
        }
        if (url.includes("student/messages/inbox")) {
            document.title = "Carnegie Learning - Messages";
            studentMessagesPageOpen = true;
        }

        // we compose a new object based on the properties of the router
        // this returned object is what's actually bound to our state tree!
        return {
            url,
            queryParams,
            params,
            studentHomePageOpen,
            studentResourcesPageOpen,
            studentResourcePageOpen,
            studentAssignmentsListPageOpen,
            studentSingularAssignmentPageOpen,
            studentCompositeAssignmentPageOpen,
            studentEditProfilePageOpen,
            studentMessagesPageOpen,
            showLaunchInNewButton,
            showAssignmentInfoButton,
            showAssignmentTeacherFeedbackButton,
        };
    }
}
